import { observer } from "mobx-react-lite";

import SharkCounter from "../../components/SharkCounter/SharkCounter";
import VideoBackground from "../../components/VideoBackground/VideoBackground";
import SharkTitle from "../../components/SharkTitle/SharkTitle";
import { TextButton } from "../../components/TextButton/TextButton";
import LogoCircle from "../../components/LogoCircle/LogoCircle";
import InactivityManager from "../../components/InactivityManager/InactivityManager";
import { ViewShell } from "../../components/Layout/ViewShell";

import { useABButtons } from "../../hooks/useABButtons";
import { useStore } from "../../store";
import { useTranslation } from "react-i18next";

export const StartView = observer(() => {
  const { t } = useTranslation();
  const { promptState, resetInactivity } = useABButtons();
  const { mainStore } = useStore();
  const currentNode = mainStore.getCurrentNode();

  function onButtonAClick() {
    mainStore.makeChoice("a");
    resetInactivity();
  }

  return (
    <ViewShell
      variant="start"
      aria-labelledby="start-view-title"
      background={<VideoBackground className="view-shell__background" />}
    >
      <div className="view-shell__content start-view__content">
        <div className="view-shell__title" id="start-view-title">
          <SharkTitle title={currentNode.title} />
        </div>

        <div
          className="start-view__cta"
          role="group"
          aria-label={`${t("start.press")} ${t("start.toStart")}`}
        >
          <p className="start-prompt-text">{t("start.press")}</p>
          <TextButton label="A" id="start-button" variant="a" onClick={onButtonAClick} />
          <p className="start-prompt-text">{t("start.toStart")}</p>
        </div>
      </div>

      <footer className="view-shell__footer start-view__footer view-shell__overlay">
        <SharkCounter />
        <div className="start-view__footer-content">
          <LogoCircle />
        </div>
      </footer>

      <InactivityManager promptState={promptState} resetInactivity={resetInactivity} />
    </ViewShell>
  );
});
